import React from 'react';

class HtmlElementInstance extends React.Component<{ el: HTMLElement; className: string }> {
    ref = React.createRef<HTMLDivElement>();

    componentDidMount() {
        this.updateEl();
    }

    componentDidUpdate(prevProps: { el: HTMLElement; className: string }) {
        if (prevProps.el !== this.props.el) this.updateEl();
    }
    updateEl() {
        if (!this.ref.current) return;
        this.ref.current.textContent = '';
        this.ref.current.appendChild(this.props.el);
    }

    render() {
        return <div className={this.props.className} ref={this.ref}></div>;
    }
}

export default HtmlElementInstance;
